<div class='ContentPreview'>
  <div class='ContentPreview-header d-flex flex-row'>
    <div
      class='ContentPreview-header-title flex-grow-1 d-flex flex-row align-items-center'>
      <div class='flex-grow-1'>
        <div class='Breadcrumbs'>
          <div class='Breadcrumbs-items'>
            <a [routerLink]="['/contents', 'content_group']"
            >
              <mat-icon class='Breadcrumbs-icon back'
              >keyboard_backspace
              </mat-icon
              >
            </a
            >
            <a
              [routerLink]="['/contents', 'content_group']"
              class='Breadcrumbs-item first'
            >Content Groups</a
            >
            <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
            <span class='Breadcrumbs-item'>{{ contentGroupName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf='content' class='ContentPreview-info mt-3 mt-sm-5 p-3 p-sm-5 d-flex flex-column'>
    <h2>Preview</h2>
    <ng-template #noSign>
      <div class='alert alert-warning'>
        <p>There is no signature text added for that template. The system will append your default profile signature
          for that email.</p>
      </div>
    </ng-template>
    <div class='ContentPreview-form mt-3 p-5'>
      <div class='ContentPreview-form-body mt-3 p-5'>
        <div class='flex-grow-1'>
          <p>- Generated Email using content: {{ getTemplateName() }}</p>
        </div>
        <div
          *ngIf="content.content_template === 'email_template1'"
          class='flex-grow-'>
          <p>Subject Line: {{ content.subject }}</p>
          <app-html-viewer [html]='content.greeting'></app-html-viewer>
          <app-html-viewer [html]='content.content_attention'></app-html-viewer>
          <app-html-viewer [html]='content.first_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.second_benefit'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_closing' [html]='content.content_closing'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_sign; else noSign' [html]='getContentSign()'></app-html-viewer>
          <app-html-viewer [html]='content.content_details'></app-html-viewer>
        </div>
        <div
          *ngIf="content.content_template === 'email_template2'"
          class='flex-grow-'>
          <p>Subject Line: {{ content.subject }}</p>
          <app-html-viewer [html]='content.greeting'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_opening' [html]='content.content_opening'></app-html-viewer>
          <app-html-viewer [html]='content.second_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.content_attention'></app-html-viewer>
          <app-html-viewer [html]='content.first_benefit'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_closing' [html]='content.content_closing'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_sign; else noSign' [html]='getContentSign()'></app-html-viewer>
          <app-html-viewer [html]='content.content_details'></app-html-viewer>
        </div>
        <div
          *ngIf="content.content_template === 'email_template3'"
          class='flex-grow-'>
          <p>Subject Line: {{ content.subject }}</p>
          <app-html-viewer [html]='content.greeting'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_opening' [html]='content.content_opening'></app-html-viewer>
          <app-html-viewer [html]='content.first_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.second_benefit'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_closing' [html]='content.content_closing'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_sign; else noSign' [html]='getContentSign()'></app-html-viewer>
          <app-html-viewer [html]='content.content_details'></app-html-viewer>
        </div>
        <div
          *ngIf="content.content_template === 'email_template4'"
          class='flex-grow-'>
          <p>Subject Line: {{ content.subject }}</p>
          <app-html-viewer [html]='content.greeting'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_closing' [html]='content.content_opening'></app-html-viewer>
          <app-html-viewer [html]='content.first_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.content_attention'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_closing' [html]='content.content_closing'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_sign; else noSign' [html]='getContentSign()'></app-html-viewer>
          <app-html-viewer [html]='content.content_details'></app-html-viewer>
        </div>
        <div
          *ngIf="
            [
              'email_template1',
              'email_template2',
              'email_template3',
              'email_template4'
            ].indexOf(content.content_template) === -1
          "
          class='flex-grow-'>
          <p>Subject Line: {{ content.subject }}</p>
          <app-html-viewer [html]='content.greeting'></app-html-viewer>
          <app-html-viewer [html]='content.first_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.second_benefit'></app-html-viewer>
          <app-html-viewer [html]='content.content_closing'></app-html-viewer>
          <app-html-viewer *ngIf='content.content_sign; else noSign' [html]='getContentSign()'></app-html-viewer>
          <app-html-viewer [html]='content.content_details'></app-html-viewer>
        </div>
      </div>
      <div *ngIf='content' class='ContentPreview-buttons d-flex flex-row mt-5'>
        <app-button
          [color]="'blue'"
          [route]='getBackButtonRoute()'
          [size]="'normal'"
          [style]="'filled'"
          [text]="'Back'"></app-button>
        <app-button
          *ngIf="sessionData?.user_type !== 'manager'"
          [color]="'orange'"
          [observeApi]='true'
          [route]='getEditButtonRoute()'
          [size]="'normal'"
          [text]="'Edit'"
          class='ms-3'></app-button>
      </div>
    </div>
  </div>
</div>
